module.exports = __webpack_public_path__ + "img/jpg-download-icon-dark.ab6f4a1b.png";